<form [formGroup]="form">
    <div *ngFor="let group of groupedRequirements" class="card mt-1">
        <div class="card-header">
            {{ group.category }}
        </div>
        <div class="card-body">
            <ng-container *ngFor="let requirement of group.items">
                <div>
                    <div class="form-check custom-checkbox">
                        <input
                            type="checkbox"
                            class="form-check-input"
                            [formControlName]="requirement.requirementKey"
                            id="{{ requirement.requirementKey }}"
                            name="{{ requirement.requirementKey }}"
                        />
                        <label class="form-check-label" for="{{ requirement.requirementKey }}">
                            {{ requirement.requirementLabel }}
                        </label>
                    </div>
                    <ng-container
                        *ngIf="requirement.hasExpiryDate && form.get(requirement.requirementKey)?.value"
                    >
                        <label
                            for="{{ requirement.requirementKey + '_expiry' }}"
                            class="form-label form-check mt-2"
                        >
                            {{ 'decision-priority-service-register-expiry-date-label' | cmsText | async }}
                        </label>
                        <div class="input-group form-check">
                            <input
                                type="text"
                                [placeholder]="
                                    'decision-priority-service-register-expiry-date-placeholder'
                                        | cmsText
                                        | async
                                "
                                class="form-control has-validation"
                                ngbDatepicker
                                #dp="ngbDatepicker"
                                [minDate]="addYearsFromToday(0, true)"
                                [maxDate]="addYearsFromToday(6)"
                                [formControlName]="requirement.requirementKey + '_expiry'"
                                id="{{ requirement.requirementKey + '_expiry' }}"
                                name="{{ requirement.requirementKey + '_expiry' }}"
                            />
                            <button class="btn btn-secondary" (click)="dp.toggle()" type="button">
                                <i class="fa fa-calendar"></i>
                            </button>
                        </div>
                        <div
                            *ngIf="
                                form.get(requirement.requirementKey + '_expiry')?.invalid &&
                                (form.get(requirement.requirementKey + '_expiry')?.dirty || submitRequested)
                            "
                            class="text-danger"
                        >
                            <span *ngIf="form.get(requirement.requirementKey + '_expiry').errors.required">
                                {{ 'priority-service-register-expiry-date-required' | cmsText | async }}
                            </span>
                            <div
                                *ngIf="
                                    form.get(requirement.requirementKey + '_expiry').errors.ngbDate?.invalid
                                "
                            >
                                {{ 'priority-service-register-expiry-date-invalid' | cmsText | async }}
                            </div>
                            <div
                                *ngIf="
                                    form.get(requirement.requirementKey + '_expiry').errors.tooFarInTheFuture
                                "
                            >
                                {{
                                    'priority-service-register-expiry-date-too-far-in-the-future'
                                        | cmsText
                                        | async
                                }}
                            </div>
                        </div>
                    </ng-container>
                </div>
            </ng-container>
        </div>
    </div>
</form>
